import React, { useState } from "react";
import { Button, Form, Select } from "antd";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { useSelector } from "react-redux";
import { convertParamsIdToNumber, onChangeProvince } from "../../../core/utils";
import RangePicker from "../../../components/RangePicker/RangePicker";
import { useHistory, useLocation } from "react-router-dom";
import { parse } from "query-string";
const { Option } = Select;
const FilterEmployee = ({
  form,
  getEmployees,
  setSearch,
  getEmployeesReport,
  cities,
  setCities,
}) => {
  const provinces = useSelector((state) => state.Store.provinces);

  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const params = parse(location.search);
  const history = useHistory();

  return (
    <FilterLayout
      onSearch={getEmployees}
      setSearch={setSearch}
      placeHolder="Search by name, username, phone number"
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      reportFilter={getEmployeesReport}
    >
      <Form
        form={form}
        name="sellReportForm"
        initialValues={{
          province_id: convertParamsIdToNumber(params.province_id),
          city_id: convertParamsIdToNumber(params.city_id),
          created_date: [
            params.created_start_date || null,
            params.created_end_date || null,
          ].filter((date) => date !== null),
          search: params.search || null,
        }}
        onFinish={() => {
          getEmployees();
          setIsVisible(false);
        }}
        requiredMark={false}
        scrollToFirstError
      >
        <FormWrapper>
          <Form.Item
            name="province_id"
            className="input-size sm:w-100 mb-10"
            colon={false}
          >
            <Select
              className="border-black-8 mb-10"
              showSearch
              value={form.getFieldValue("province_id")}
              onChange={(value) =>
                onChangeProvince(
                  value,
                  () => {
                    form.setFieldValue("province_id", value);
                    form.setFieldValue("city_id", null);
                  },
                  setCities
                )
              }
              placeholder="Provinces"
            >
              <Option value={null} name="All Provinces">
                All Provinces
              </Option>
              {provinces?.map((province) => {
                return (
                  <Option key={province.id} value={province.id}>
                    {province.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            className="input-size sm:w-100"
            style={{ marginBottom: "10px" }}
            name="created_date"
            colon={false}
          >
            <RangePicker
              className="border-black-8 w-100"
              currentRange={[
                params.created_start_date || null,
                params.created_end_date || null,
              ]}
              onGetRange={(value) => form.setFieldValue("created_date", value)}
            />
          </Form.Item>
          <Form.Item className="sm:w-100 mb-10" name={"city_id"}>
            <Select
              className="border-black-8 mb-10"
              showSearch
              onChange={(value) => form.setFieldValue("city_id", value)}
              placeholder={"City"}
            >
              <Option value={null} name="All Cities">
                All Cities
              </Option>
              {cities?.map((city) => {
                return (
                  <Option key={city.id} value={city.id}>
                    {city.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <div />
          <Button
            className="button-red input-size sm:w-100 "
            onClick={() => {
              history.push(window.location.pathname);
              setSearch("");
              setIsVisible(false);
              setTimeout(() => {
                form.resetFields();
                form.submit();
              }, 100);
            }}
          >
            Reset Filters
          </Button>
          <Button
            className="button-secondary input-size sm:w-100"
            htmlType="submit"
          >
            Filter
          </Button>
        </FormWrapper>
      </Form>
    </FilterLayout>
  );
};

export default FilterEmployee;
